import { UserDashboardProto } from "../proto/generated/user-preference";

class EmbeddedDataManager {
    getUserDashboards = async (): Promise<UserDashboardProto[]> => {

        return []
    }
}

export default EmbeddedDataManager;